export default __webpack_public_path__ + "static/social-f82b3fd45b25ba2dbed44cdd1ac9944a.svg";